import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=08a99a5a&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./pagination.vue?vue&type=style&index=0&id=08a99a5a&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "08a99a5a",
  "949e4b84"
  
)

export default component.exports